import { render, staticRenderFns } from "./y_detail.vue?vue&type=template&id=0e9be874&scoped=true&"
import script from "./y_detail.vue?vue&type=script&lang=js&"
export * from "./y_detail.vue?vue&type=script&lang=js&"
import style0 from "./y_detail.vue?vue&type=style&index=0&id=0e9be874&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e9be874",
  null
  
)

export default component.exports